import { render } from "./vdmLargeImg.vue?vue&type=template&id=3f9b66de&scoped=true"
import script from "./vdmLargeImg.vue?vue&type=script&lang=js"
export * from "./vdmLargeImg.vue?vue&type=script&lang=js"

import "./vdmLargeImg.vue?vue&type=style&index=0&id=3f9b66de&lang=scss&scoped=true"

import exportComponent from "/Users/cw/Desktop/BME/screen_project_315/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f9b66de"]])

export default __exports__